import { render, staticRenderFns } from "./SiskeudesTransactionContent.vue?vue&type=template&id=38aa96fc&lang=pug"
import script from "./SiskeudesTransactionContent.vue?vue&type=script&lang=js"
export * from "./SiskeudesTransactionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports